import { OliveDocuSignTheme } from '../docusign-themes/olive'
import { useTheme } from './useTheme'

export const useThemeName = () => {
  const { name } = useTheme()
  const themeName = name || OliveDocuSignTheme.name
  return themeName
}
